<template>
  <div
    class="slide sidearm-mm-gallery-transition bg-black relative"
    data-anchor="gallery-end"
  >
    <div class="flex h-100">
      <div
        class="sidearm-mm-gallery-transition__content h-100 col-3-of-8 flex flex-align-center flex-justify-end"
      >
        <div class="sidearm-mm-gallery-transition__body col-6-of-8 relative">
          <h3
            class="sidearm-mm-gallery-transition__title type-hero mb-4 mt-0 pr-2"
          >
            Want to see more photos?
          </h3>
          <a
            href="/galleries"
            class="sidearm-mm-btn --ghost sidearm-mm-gallery-transition__button"
            >Photo Galleries</a
          >
        </div>
      </div>
      <div
        v-if="section.galleries && section.galleries.length"
        :style="{
          backgroundImage: `url('${section.galleries[0].images[0].large}')`
        }"
        class="sidearm-mm-gallery-transition__aside h-100 col-5-of-8 relative"
      ></div>
      <background-element
        class="sidearm-mm-gallery-transition__top-background-element  col-4-of-8 absolute"
      />
      <background-element
        class="sidearm-mm-gallery-transition__bottom-background-element  col-2-of-8 absolute"
      />
    </div>
    <div
      class="sidearm-mm-gallery-transition__divider sidearm-mm-gallery-transition__divider--start col-1-of-8 absolute flex flex-justify-center"
    >
      <span></span>
    </div>
    <div
      class="sidearm-mm-gallery-transition__divider sidearm-mm-gallery-transition__divider--end col-1-of-8 absolute flex flex-justify-center flex-align-center h-100"
    >
      <span></span>
    </div>
  </div>
</template>

<script>
import BackgroundElement from "@/components/Globals/BackgroundElement";

export default {
  name: "SlideGalleryTransition",
  components: {
    BackgroundElement
  },
  data: () => ({}),
  computed: {
    section() {
      if (!this.$root.data) {
        return null;
      }
      return this.$root.data.galleries_section;
    }
  }
};
</script>
<style lang="scss" scoped>
.sidearm-mm-gallery-transition {
  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(#{grid_percent(120)} + #{$header-height});
    content: "";
    background: $color-black;
    pointer-events: none;
    transition: transform 0.7s, opacity 0.7s, height 0.7s;
    transform: translateY(-#{grid_percent(120)});
  }
  &::after {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: grid_percent(120);
    content: "";
    background: $color-black;
    pointer-events: none;
    transition: transform 0.7s, opacity 0.7s, height 0.7s;
    transform: translateY(#{grid_percent(120)});
  }
  &__title {
    &::after {
      background-color: $color-black;
    }
  }
  &__button {
    color: $text-on-primary;
    border-color: $text-on-primary;
  }
  &__divider {
    top: calc(50% + #{$header-height/2});
    transform: translateY(-50%);
    z-index: 1;
    > span {
      display: inline-block;
      border-radius: 50%;
      border: 1px solid $color-white;
      display: block;
      height: 1.5rem;
      width: 1.5rem;
    }
    &--start {
      left: 0;
      &::before {
        width: calc(50% - 0.75rem);
        height: 1px;
        position: absolute;
        top: 50%;
        right: calc(50% + 0.75rem);
        content: "";
        background: $color-white;
      }
    }
    &--end {
      left: 50%;
      height: 100%;
      &::before {
        width: calc(50% - 0.75rem);
        height: 1px;
        position: absolute;
        top: 50%;
        left: calc(50% + 0.75rem);
        content: "";
        background: $color-white;
      }
      &::after {
        width: 1px;
        height: 50%;
        content: "";
        background: $color-white;
        position: absolute;
        top: 50%;
        right: 0;
      }
    }
  }
  &__content {
    padding-top: #{$header-height};
    // background: $color-primary;
    background: url("~@/assets/396696.jpg");
    color: $text-on-primary;
  }
  &__body {
    z-index: 2;
  }
  &__aside {
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
    &::after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      content: "";
      background: rgba(0, 0, 0, 0.8);
    }
  }
  &__top-background-element {
    top: calc(50% + #{$header-height/2});
    transform: translateY(-50%);
    left: 0;
    height: calc(50% - #{$header-height/2});
    z-index: 1;
  }
  &__bottom-background-element {
    top: calc(50% + #{$header-height/2});
    transform: translateY(-100%);
    left: 62.5%;
    height: calc((50% - #{$header-height/2}) / 2);
    z-index: 1;
  }
}
</style>
